import cn from 'classnames';

import UILoader from '../Item';
import styles from './styles.module.scss';

const UILoaderWrap = ({
  children,
  loading,
  className,
  bgTransparent = false,
}) => {
  return (
    <div className={cn(styles.loader__wrap, className)}>
      {loading && <UILoader bgTransparent={bgTransparent} primary />}
      {children}
    </div>
  );
};

export default UILoaderWrap;
